/**
 * @file 快速上手
 * @author FengGuang(fengguang01@baidu.com)
 */
import React from 'react';

import PictureCardGroup from '../../../../components/picture-card/PictureCardGroup';
import contactsListData from './contactsListData';


const ContactsList: React.FC = () => {
    return (
        <PictureCardGroup
            className="paddle-contacts-list"
            option={contactsListData}
        />
    );
};

export default ContactsList;
